<cx-order-summary [cart]="cart$ | async"></cx-order-summary>
